import Button from '@mui/material/Button';
import { useState, useEffect, useContext } from 'react';
import AccountDetails from './AccountDetails';
import { Context } from '../../AuthContext';

const ProfilePage = () => {
  const { user, authLoading } = useContext(Context);
  const [userFromDb, setUserFromDb] = useState('');

  const handleButtonClick = (url) => {
    window.open(url, '_blank');
  };

  useEffect(() => {
    if (authLoading) return;

    document.title = 'Profile - The Simple Platform';
    const getUser = async () => {
      const userFromDb = await fetchUser();
      setUserFromDb(userFromDb);
    };
    getUser();
  }, [authLoading, user]);

  const fetchUser = async () => {
    const token = await user.getIdToken();
    const url = process.env.REACT_APP_FLASK_WEBSERVER + 'get_user';
    const res = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const userData = await res.json();
    return userData;
  };

  return (
    <div style={{ width: '75vw' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2>Account Details</h2>
        <div>
          <Button
            variant="outlined"
            sx={{ textTransform: 'none', margin: '0 10px' }}
            onClick={() => {
              handleButtonClick('https://www.simple-platform.com/terms-and-conditions');
            }}
          >
            Terms of Use
          </Button>
          <Button
            variant="outlined"
            sx={{ textTransform: 'none', margin: '0 10px' }}
            onClick={() => {
              handleButtonClick('https://www.simple-platform.com/privacy-policy');
            }}
          >
            Privacy Policy
          </Button>
          <Button
            variant="outlined"
            sx={{ textTransform: 'none' }}
            onClick={() => {
              handleButtonClick('https://www.simple-platform.com/data-sources');
            }}
          >
            Data Sources
          </Button>
        </div>
      </div>

      {userFromDb && <AccountDetails user={user} userFromDb={userFromDb} />}
    </div>
  );
};
export default ProfilePage;
